import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "zoom",
  "use": "zoom-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"zoom\"><path d=\"M23.65 22l-4.42-4.42a10.83 10.83 0 1 0-1.7 1.7L22 23.65a1.21 1.21 0 0 0 1.7 0 1.2 1.2 0 0 0-.05-1.65zM2.4 10.8a8.4 8.4 0 1 1 14.35 5.92A8.39 8.39 0 0 1 2.4 10.8z\" /><path d=\"M14.4 9.6H12V7.2a1.2 1.2 0 1 0-2.4 0v2.4H7.2a1.2 1.2 0 0 0 0 2.4h2.4v2.4a1.2 1.2 0 1 0 2.4 0V12h2.4a1.2 1.2 0 0 0 0-2.4z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol